import List from "@/components/list"


const BaseTable = ctx => {
  const { listeners} = ctx;
  const RCSelectionChange = listeners["selection-change"] || function () {};


  const Deal = ({ props: { vo } }) => {
    const remove = () => {
      const { row, $index } = vo
      listeners.remove && listeners.remove(row, $index)
    }

    return (
      <div class="deal-group">
        <el-button type="text" onClick={remove}>移除</el-button>
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
      width: 100
    },
    {
      label: "视频名称",
      prop: "name",
      minWidth: "200",
      showOverflowTooltip: true
    },
    {
      label: "状态",
      prop: "onlineStatusName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...ctx}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default BaseTable;
